import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { TEXT_STYLES } from './styles';

export const CustomTooltip = ({ active, payload }) => {
    if (!active || !payload || !payload.length) {
        return null;
    }

    const data = payload[0].payload;
    const maxWidth = 300; // Maximum width for the tooltip

    return (
        <Paper
            elevation={2}
            sx={{
                p: 2,
                backgroundColor: 'background.paper',
                maxWidth: maxWidth,
                border: '1px solid #e0e0e0',
                borderRadius: 1
            }}
        >
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column',
                gap: 0.5,
            }}>
                <Typography 
                    sx={{ 
                        fontSize: '14px',
                        fontWeight: 500,
                        color: '#333',
                        wordBreak: 'break-word',
                        whiteSpace: 'normal',
                        lineHeight: 1.4
                    }}
                >
                    {data.text}
                </Typography>
                <Typography 
                    sx={{ 
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: '#000',
                        mt: 0.5
                    }}
                >
                    {data.value}%
                </Typography>
                <Typography 
                    sx={{ 
                        fontSize: '12px',
                        color: '#666',
                        whiteSpace: 'nowrap',
                        mt: 1,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5
                    }}
                >
                    <span style={{ color: '#999' }}>Respondentų:</span> {data.count}
                </Typography>
            </Box>
        </Paper>
    );
};
